"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTotalClassSkuCountForStrategyMatrix = void 0;
const react_1 = require("@apollo/client/react");
const gql_1 = require("../gql");
const client_utils_1 = require("../../../client/client.utils");
const useGetTotalClassSkuCountForStrategyMatrix = ({ productTreeId, catalog, selectedAttribute, }) => {
    var _a;
    const { data, error, networkStatus, } = (0, react_1.useQuery)(gql_1.GET_TOTAL_CLASS_SKU_COUNT_FOR_STRATEGY_MATRIX, {
        variables: {
            productTreeId,
            ids: [catalog],
            attribute: selectedAttribute,
        },
        fetchPolicy: 'no-cache',
        skip: !productTreeId || !selectedAttribute || !catalog,
    });
    const terminalNodesTotal = (_a = data === null || data === void 0 ? void 0 : data.catalogs) === null || _a === void 0 ? void 0 : _a.edges;
    return {
        data: terminalNodesTotal,
        IsLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        error: error === null || error === void 0 ? void 0 : error.message,
    };
};
exports.useGetTotalClassSkuCountForStrategyMatrix = useGetTotalClassSkuCountForStrategyMatrix;
